import { render, staticRenderFns } from "./Loginphone.vue?vue&type=template&id=bc4d2658&"
import script from "./Loginphone.vue?vue&type=script&lang=js&"
export * from "./Loginphone.vue?vue&type=script&lang=js&"
import style0 from "./Loginphone.vue?vue&type=style&index=0&id=bc4d2658&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports